import {VACCINE_TYPES} from "../../../utils/constants";
import {OptionButton} from "../OptionButton";
import React from "react";

interface VaccineButtonsProps {
  selected: string[];
  onChangeSelected: (type: object) => void;
}

const VaccineButtons = ({
  selected,
  onChangeSelected,
}: VaccineButtonsProps) => (
  <div className="flex gap-2 mb-2 flex-wrap px-2 py-2">
    {VACCINE_TYPES
      .filter(type => type.name !== '不限')
      .map(type => (
        <OptionButton
          key={type.name}
          isSelected={selected.includes(type.name)}
          onClick={() => onChangeSelected(type)}
          label={type.name}
        />
      ))
    }
  </div>
)

export default VaccineButtons